import TopicListPage from './TopicListPage';
import TopicListPageContainer from './TopicListPage.container';

export default TopicListPageContainer(TopicListPage);
